'use strict';

/* global $ */

import { Ajax } from 'utils/ajax';
import { Like } from 'modules/like';

function Map(options) {

	let opt = $.extend(true, {}, options);

	function initBlock(el) {
		let $el = $(el);

		let location = $el.data('location').split(',');
		let scale = $el.data('scale');
		//let handler = $el.data('map_handler');
		//let event = $el.data('map_event');

		opt = $.extend({
			mapSelector: opt.selector+'__block',
			itemSelector: opt.selector+'__item',
			itemSelectorHint: opt.selector+'__item-hint',
			formGeolocation: opt.selector+'__geolocation',
			btnEditSelector: opt.selector+'__edit',
			btnFixedSelector: opt.selector+'__fixed',
			inputAddress: opt.selector+'__address',
			inputLatitude: opt.selector+'__latitude',
			inputLongitude: opt.selector+'__longitude',
			inputCity: opt.selector+'__city',
			inputDivision: opt.selector+'__division',
			inputHeadman: opt.selector+'__headman',
			mapHanler: $el.data('map_handler'),
			mapEvent: $el.data('map_event'),
			objectHanler: $el.data('object_handler'),
			objectEvent: $el.data('object_event'),
			//behaviors: opt.behaviors,
			//controls: opt.controls,
			controls: ['geolocationControl','zoomControl','searchControl','fullscreenControl'],
			//behaviors: [],
			center: location,
			zoom: scale,
			eps: .0005
		}, opt);

		if ($el.data('geolocation') == 1) { opt.getGeoloacation = true };
		if ($el.data('bounds') == 1) { opt.setBounds = true };
		if ($el.data('clusterer') == 1) { opt.Clusterer = true };
		if ($el.data('click_pointer') == 1) { opt.clickPointer = true };
		if ($el.data('set_pointer') == 1) { opt.setPointer = true };
		if ($el.data('get_address') == 1) { opt.getAddress = true };
		if ($el.data('use_form_data') == 1) { opt.useFormData = true };
		if ($el.data('search') == 1) { opt.initSearch = true };

		let myMap, $map;
		let placemarks = {};

		$map = $(opt.mapSelector);
		if (!$map.length) return;
		console.log('[ Map/init ]');

		let items = {};
		$(opt.itemSelector, this).each(function(i) {
			let data = $(this).data();
			let id = data.id;

			if (opt.useFormData == true && i == 0) {
				data.coords = $('[name="' + $('input[name="field"]').val() + '"]').val();
				data.type = $('input[name="type"]').val();
				if (!data.coords) {
					data.coords = [[[location[0]*1-0.01,location[1]*1-0.01],[location[0]*1-0.01,location[1]*1+0.01],[location[0]*1+0.01,location[1]*1+0.01],[location[0]*1+0.01,location[1]*1-0.01]]];
					data.coords = JSON.stringify(data.coords);
				}
			} else {
				data.coords = JSON.stringify(data.coords);
			}
			items[id] = data;
			if ($(this).find(opt.itemSelectorHint).length) items[id].hint = $(this).find(opt.itemSelectorHint).html();
		});

		myMap = new ymaps.Map(
			$map.get(0),
			opt, 
			{
				yandexMapDisablePoiInteractivity: true,
				suppressMapOpenBlock: true
			}
		);

		//let hintOptions = new ymaps.Hint(myMap, {
		//	offset: [50, 50]
		//});
		//console.log(hintOptions);
		//myMap = new ymaps.Map($map.get(0), {
		//    behaviors: opt.behaviors,
		//    controls: opt.controls,
		//    center: opt.center,
		//    zoom: opt.zoom
		//});

		//myMap.controls.add('zoomControl');
		//myMap.controls.add('typeSelector');

		$map.mouseenter(function(e) {
			myMap.behaviors.disable('scrollZoom');
		});
/*
		var MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
			'<div class="popover">' +
			'<a class="popover__close" href="#">&times;</a>' +
			'<div class="popover__inner">' +
			'$[[options.contentLayout observeSize minWidth=235 maxWidth=235 maxHeight=350]]' +
			'</div>' +
			'</div>', {
			build: function () {
				this.constructor.superclass.build.call(this);

				this._$element = $('.popover', this.getParentElement());

				this.applyElementOffset();

				this._$element.find('.popover__close')
					.on('click', $.proxy(this.onCloseClick, this));
			},
			clear: function () {
				this._$element.find('.popover__close')
					.off('click');

				this.constructor.superclass.clear.call(this);
			},
			onSublayoutSizeChange: function () {
				MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

				if(!this._isElement(this._$element)) {
					return;
				}

				this.applyElementOffset();

				this.events.fire('shapechange');
			},
			applyElementOffset: function () {
				this._$element.css({
					left: -(this._$element[0].offsetWidth / 2),
					top: -(this._$element[0].offsetHeight)
				});
			},
			onCloseClick: function (e) {
				e.preventDefault();

				this.events.fire('userclose');
			},
			getShape: function () {
				if(!this._isElement(this._$element)) {
					return MyBalloonLayout.superclass.getShape.call(this);
				}
				var position = this._$element.position();
				return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
					[position.left, position.top], [
						position.left + this._$element[0].offsetWidth,
						position.top + this._$element[0].offsetHeight
					]
				]));
			},
			_isElement: function (element) {
				return element && element[0];
			}
		});

		var MyBalloonContentLayout = ymaps.templateLayoutFactory.createClass(
			'<div class="popover__content">$[properties.balloonContent]</div>'
		);
*/

		let myPointer;
		let geoobjects = {};
		let cluster = [];

		for (var j in items) {
			//console.log(items[j]);
			let params = {
				draggable: false,
				strokeWidth: 3,
				strokeStyle: 'solid',
				strokeOpacity: 0.8,
				fillOpacity: 0.3,
				interactiveZIndex: true,
				//opacity: 1,
				//balloonShadow: false,
				//balloonLayout: MyBalloonLayout,
				//balloonContentLayout: MyBalloonContentLayout,
				//balloonPanelMaxMapArea: 0,
				//hideIconOnBalloonOpen: true,
				//iconLayout: 'default#image',
				//iconImageHref: opt.icon,
				//iconImageSize: [100, 100],
				//iconImageOffset: [-50, -50],
			};
			if (items[j].color) {
				params.fillColor = items[j].color;
				params.strokeColor = items[j].color;
			}
			if (items[j].strokeColor) {
				params.strokeColor = items[j].strokeColor;
			}
			if (items[j].fill) {
				params.fill = true;
			} else {
				params.fill = false;
			}
			params.hintOffset = [20,-70];
			var myGeoObject = new ymaps.GeoObject({
					geometry: {
						type: items[j].type,
						coordinates: JSON.parse(items[j].coords)
					},
					properties: {
						index: j,
						//clusterCaption: annotation,
						//content: items[j].info,
						balloonContent: items[j].balloon,
						hintContent: items[j].hint,
					},
				}, params);
			myMap.geoObjects.add(myGeoObject);
			if (opt.objectEvent) {
				myGeoObject.events.add(opt.objectEvent, function (e) {
					if (opt.clickPointer == true) {
						setPointer(e);
					}
					callHandler(e);
				});
			}
			//if (params.fill == false) {
				myGeoObject.events
					.add('mouseenter', function (e) {
						let strokeColor = e.get('target').options.get('strokeColor');
						e.get('target').options.set('tmp', strokeColor);
						let fillColor = e.get('target').options.get('fillColor');
						e.get('target').options.set('strokeColor', fillColor);
						if (e.get('target').options.get('fill') == true) {
							e.get('target').options.set('fill', false);
						} else {
							e.get('target').options.set('fill', true);
						}
					})
					.add('mouseleave', function (e) {
						let strokeColor = e.get('target').options.get('tmp');
						e.get('target').options.set('strokeColor', strokeColor);
						if (e.get('target').options.get('fill') == true) {
							e.get('target').options.set('fill', false);
						} else {
							e.get('target').options.set('fill', true);
						}
					});
			//}
			geoobjects[j] = myGeoObject;
			cluster.push(myGeoObject);
		}

		if (cluster.length) {
			if (opt.Clusterer == true) {
				console.log('[ Map/Set Clusterer ]');
				let clusterer = new ymaps.Clusterer({clusterDisableClickZoom: false});
				clusterer.add(cluster);
				myMap.geoObjects.add(clusterer);
			}
		}

		let storage = ymaps.geoQuery(myMap.geoObjects);

		console.log(storage.getBounds());

		if (opt.clickPointer == true) {
			myMap.events.add('click', function (e) {
				setPointer(e);
				callHandler(e);
			});
		}

		if (opt.setPointer == true) {
			setPointer(null, location);
		}

		$(opt.btnEditSelector).on('click', function(e) {
			e.preventDefault();
			if (!$(this).hasClass('disabled')) {
				geoobjects['p0'].editor.startEditing();
				$(this).addClass('disabled');
				$(opt.btnFixedSelector).removeClass('disabled');
			}
			if (opt.useFormData == true) {
				$(this).parents('form').find('[type="submit"]').prop('disabled', true);
			}
			let bounds = geoobjects['p0'].geometry.getBounds();
			setBounds(bounds);
		});

		$(opt.btnFixedSelector).on('click', function(e) {
			e.preventDefault();
			if (!$(this).hasClass('disabled')) {
				geoobjects['p0'].editor.stopEditing();
				let coords = geoobjects['p0'].geometry.getCoordinates();
				console.log(coords);
				$(this).addClass('disabled');
				$(opt.btnEditSelector).removeClass('disabled');
				if (opt.useFormData == true) {
					$('[name="' + $('input[name="field"]').val() + '"]').val(JSON.stringify(coords));
				}
			}
			if (opt.useFormData == true) {
				$(this).parents('form').find('[type="submit"]').prop('disabled', false);
			}
		});

		let myDivision;
		let coordsDivision = [];
		let upper;
		$(opt.formGeolocation).on('submit', function(e) {
			e.preventDefault();
			let form = $(this);
			let params = form.serializeArray();
			console.log(params);
			let street = $(this).find('[name=street]').val();
			let houses = $(this).find('[name=houses]').val();
			console.log(street, houses);
			houses = houses.replace( /\s/g, '');
			houses = houses.split(',');
			$.each(houses, function(index, value) {
				console.log(street + ' ' + value);
				let address = 'Челябинск ' + street + ' ' + value;
				ymaps.geocode(address).then(function (res) {
					console.log(res);
					let firstGeoObject = res.geoObjects.get(0);

					//console.log('AddressCoords', firstGeoObject.geometry.getPixelGeometry({}));
					//console.log('AddressCoords', ymaps.util.bounds.fromPoints([firstGeoObject.geometry.getCoordinates()]));
					//console.log('AddressBounds', firstGeoObject.properties.get('boundedBy'));
					//let bounded = firstGeoObject.properties.get('boundedBy');
					let location = firstGeoObject.geometry.getCoordinates();
					console.log(location);
					coordsDivision.push({x:location[0], y:location[1]});
					//let x0 = bounded[0] - 0.001;
					//let y0 = bounded[1] - 0.0005;
					//let x1 = bounded[0] + 0.001;
					//let y1 = bounded[1] + 0.0005;
					if (index + 1 == houses.length) {
						console.log(coordsDivision);
/*
						upper = upperLeft(coordsDivision);

						console.log("points :: ", coordsDivision);
						console.log("upper  :: ", upper);
						coordsDivision.sort(pointSort);
						console.log("sorted :: ", coordsDivision);
*/
						let hull = convexhull.makeHull(coordsDivision);
						console.log(hull);
						coordsDivision = [];
						$.each(hull, function(index, value) {
							coordsDivision.push([value.x, value.y]);
						});
						if (!myDivision) {
							console.log('Create Polygon');
							myDivision = new ymaps.Polygon([coordsDivision]);
							myMap.geoObjects.add(myDivision);
						} else {
							myDivision.geometry.setCoordinates([coordsDivision]);
						}
						let bounds = myDivision.geometry.getBounds();
						console.log(bounds);
						setBounds(bounds);
					}
				});
			});
		});

		//$(opt.btnDraggSelector).on('click', function(e) {
		//    e.preventDefault();
		//    myGeoObject.options.set('draggable', true);
		//});

		$(opt.btnEditSelector).click();

		if (opt.getGeoloacation == true) {
			getGeolocation();
		}

		if (opt.setBounds == true) {
			setBounds();
		}

		if (opt.initSearch == true) {
			initSearchControl();
		}

		$(opt.inputDivision).on('change', function(e){
			let id = $(this).val();
			console.log('Division id: ', id, geoobjects[id]);
			let bounds = geoobjects[id].geometry.getBounds();
			console.log(bounds);
			setBounds(bounds);
			if ($(opt.inputAddress).length) {
				$(opt.inputAddress).val('');
			}
		});

		function setPointer(e, coords) {
			if (!coords) {
				coords = e.get('coords');
			}
			console.log(coords);
			if (!myPointer) {
				myPointer = new ymaps.GeoObject({
					geometry: {
						type: 'Point',
						coordinates: coords
					}
				});
				myMap.geoObjects.add(myPointer);
			} else {
				myPointer.geometry.setCoordinates(coords);
			}
			if ($(opt.inputLatitude).length && $(opt.inputLongitude).length) {
				$(opt.inputLatitude).val(coords[0]);
				$(opt.inputLongitude).val(coords[1]);
			}
			console.log(opt.getAddress);
			if (opt.getAddress == true) {
				getAddress(coords);
			}
		}

		function setBounds(bounds) {
			console.log('[ Map/Set bounds ]');
			if (!bounds) {
				bounds = myMap.geoObjects.getBounds();
			}
			myMap.setBounds(bounds, {
				checkZoomRange:true
			}).then(function() {
				let zoom = myMap.getZoom();
				if (zoom > 15 || zoom == 0) myMap.setZoom(15);
			});            
		}

		function getGeolocation() {
			ymaps.geolocation.get({
				// Выставляем опцию для определения положения по ip    
				provider: 'auto',
				// Карта автоматически отцентрируется по положению пользователя.
				// mapStateAutoApply: true
			}).then(function (result) {
				myMap.geoObjects.add(result.geoObjects);
			});
		}

		function getAddress(coords) {
			myPointer.properties.set('iconCaption', 'поиск...');
			ymaps.geocode(coords).then(function (res) {
				let firstGeoObject = res.geoObjects.get(0);

				console.log('AddressLine', firstGeoObject.getAddressLine());
				console.log(firstGeoObject.getLocalities(), firstGeoObject.getThoroughfare(), firstGeoObject.getPremiseNumber(), firstGeoObject.getPremise());
				let localities = firstGeoObject.getLocalities();
				localities.shift();
				if (!localities.length) { localities = undefined }
				let address = [
					localities, firstGeoObject.getThoroughfare(), firstGeoObject.getPremiseNumber(), firstGeoObject.getPremise()
				].filter(Boolean).join(', ');
				myPointer.properties
					.set({
						// Формируем строку с данными об объекте.
						iconCaption: address,
						// В качестве контента балуна задаем строку с адресом объекта.
						balloonContent: firstGeoObject.getAddressLine()
					});

				if ($(opt.inputAddress).length) {
					$(opt.inputAddress).val(address);
				}
			});
		}

		function setAddress(address) {
			ymaps.geocode(address).then(function (res) {
				let firstGeoObject = res.geoObjects.get(0);

				console.log('AddressLine', firstGeoObject.getAddressLine());
				console.log(firstGeoObject.getLocalities(), firstGeoObject.getThoroughfare(), firstGeoObject.getPremiseNumber(), firstGeoObject.getPremise());
				let localities = firstGeoObject.getLocalities();
				localities.shift();
				if (!localities.length) { localities = undefined }
				let coords = firstGeoObject.geometry.getCoordinates();
				let bounds = firstGeoObject.properties.get('boundedBy');
				let address = [
					localities, firstGeoObject.getThoroughfare(), firstGeoObject.getPremiseNumber(), firstGeoObject.getPremise()
				].filter(Boolean).join(', ');
				setPointer(undefined, coords);
				setBounds(bounds);
				if ($(opt.inputDivision).length && $(opt.inputHeadman).length) {
					console.log('[ Map/Set division and headman ]');
					let params = {
						coords: coords
					}
					Ajax.get('get_division', params).then((data) => {
						if (data.headman_division_id) {
							let division = data.headman_division_id;
							$(opt.inputDivision).val(division);
						}
						if (data.headman_id) {
							let headman = data.headman_id;
							$(opt.inputHeadman).val(headman);
						}
					}).catch(function(error) {
						throw new Error(error);
					});
				}
				callHandler(undefined, myPointer);
				if ($(opt.inputAddress).length) {
					$(opt.inputAddress).val(address);
				}
			});
		}

		function initSearchControl(params) {
			console.log('[ Map/Init searchControl ]');
			if ($(opt.inputAddress).length) {
				let id = $(opt.inputAddress).attr('id');
				let suggestView = new ymaps.SuggestView(id, {
					boundedBy: storage.getBounds()
				});
				suggestView.events.add('select', function (e) {
					let address = e.get('item').value;
					console.log(address);
					$(opt.inputDivision).prop('disabled', false);
					$(opt.inputHeadman).prop('disabled', false);
					setAddress(address);
					suggestView.state.set({
						open: false,
						panelClosed: true,
						items: []
					});
				});
			}
			let searchControl = myMap.controls.get('searchControl');
			searchControl.options.set({
				boundedBy: storage.getBounds(),
				strictBounds: true,
				noPlacemark: true, 
				placeholderContent: 'Введите адрес'
			});
			searchControl.events.add('resultshow', function (e) {
				let coords = searchControl.getResultsArray()[e.get('index')].geometry.getCoordinates();
				let obj = storage.searchContaining(coords).get(0);
				console.log(obj, obj.properties.get('hintContent'));
				obj.options.set('fill', true);
				obj.hint.show();
				console.log(obj, obj.properties);
			});
		}

		function callHandler(e, object) {
			console.log(object);
			let coords = e.get('coords') || object.geometry.getCoordinates();
			let geoObject = e.get('target') || object;
			if (typeof geoObject.geometry == 'undefined') return;
			let type = geoObject.geometry.getType();
			let index = geoObject.properties.get('index');

			let ids = [];
			if (type == 'Point') {
				ids.push(index);
			} else {
				$.each(geoobjects, function(key, value) {
					if (geoobjects[key].geometry.contains(coords)) {
						let division_id = geoobjects[key].properties.get('index');
						console.log('Территория', division_id);
						//geoobjects[key].options.set('fill', true);
						ids.push(division_id);
					} else {
						//geoobjects[key].options.set('fill', false);
					}
				});
			}

			if (opt.objectHanler && ids.length) {
				let params = {
					object_id: ids
				}
				Ajax.get(opt.objectHanler, params).then((data) => {
					delete self.loading;
					self.$modal = $(document.createElement('div')).addClass('modal fade').html(data.html).appendTo('body').modal();
					self.$modal.on('hidden.bs.modal', function() {
						self.$modal.remove();
						delete self.$modal;
					});
					self.Map = new Map({
						selector: '.js-map-modal',
						//useFormData: true
					});
					self.Like = new Like({
						selector: '.js-likes'
					});
					$('[data-toggle="tooltip"], [data-tooltip="true"]').tooltip({
						trigger : 'hover'
					});
					$('[data-toggle="popover"]').popover({
						html: true,
						content: function() {
							let elementId = $(this).attr('data-popover-content');
							return $(elementId).html();
						}
					});
					let qrcode = document.getElementById('qrcode');
					if (qrcode) {
						console.log(qrcode.dataset.string);
						if (qrcode) {
							let string = qrcode.dataset.string;
							this.qrcode = new QRCode(qrcode, {
								text: string,
								width: 256,
								height: 256,
								colorDark : '#000000',
								colorLight : '#ffffff',
								correctLevel : QRCode.CorrectLevel.H
							});
						}
					}
				}).catch(function(error) {
					throw new Error(error);
				});
			}

			if ($(opt.inputDivision).length) {
				$(opt.inputDivision).val(ids).change();
			}
		}


		function Distance(upper, location) {
	        var dX = location[0] - upper[0];
	        var dY = location[1] - upper[1];
	        return Math.sqrt((dX*dX) + (dY*dY));
		}

		function Slope(upper, location) {
	        var dX = location[0] - upper[0];
	        var dY = location[1] - upper[1];
	        return dY / dX;
		}

		function pointSort(p1, p2) {
		    // Exclude the 'upper' point from the sort (which should come first).
		    if (p1[0] == upper[0] && p1[1] == upper[1]) return -1;
		    if (p2[0] == upper[0] && p2[1] == upper[1]) return 1;

		    // Find the slopes of 'p1' and 'p2' when a line is 
		    // drawn from those points through the 'upper' point.
		    var m1 = Slope(upper, p1);
		    var m2 = Slope(upper, p2);

		    // 'p1' and 'p2' are on the same line towards 'upper'.
		    if(m1 == m2) {
		        // The point closest to 'upper' will come first.
		        return Distance(upper, p1) < Distance(upper, p2) ? -1 : 1;
		    }

		    // If 'p1' is to the right of 'upper' and 'p2' is the the left.
		    if(m1 <= 0 && m2 > 0) return -1;

		    // If 'p1' is to the left of 'upper' and 'p2' is the the right.
		    if(m1 > 0 && m2 <= 0) return 1;

		    // It seems that both slopes are either positive, or negative.
		    return m1 > m2 ? -1 : 1;
		}

		function upperLeft(points) {
		    var top = points[0];
		    console.log(top);
		    for(var i = 1; i < points.length; i++) {
		        var temp = points[i];
		        if(temp[1] > top[1] || (temp[1] == top[1] && temp[0] < top[0])) {
		            top = temp;
		            console.log(top);
		        }
		    }
		    return top;
		}
	}


	console.log($(opt.selector).length);
	if ($(opt.selector).length == 0) return;
	if (typeof ymaps !== 'undefined') {
		ymaps.ready(function() {
			$(opt.selector).each(function() {
				initBlock(this);
			});
		});
	} else {
		let count = 0;
		let timerId = setInterval(function() {
			count++;
			console.log('[ Map/test ] ' + count);
			if (typeof ymaps !== 'undefined') {
				ymaps.ready(function() {
					$(opt.selector).each(function() {
						initBlock(this);
					});
				});
				clearInterval(timerId);
			}
			if (count > 2) {
				clearInterval(timerId);
			}
		}, 500);
	}
}

export {
	Map
};
